/* eslint-disable import/no-cycle */
import { configureStore } from '@reduxjs/toolkit';

import companySlice from './company';
import eventSlice from './event';
import featureFlagSlice from './flag';
import kioskSlice from './kiosk';
import sessionSlice from './session';
import systemSlice from './system';
import userSlice from './user';

const store = configureStore({
  reducer: {
    system: systemSlice.reducer,
    event: eventSlice.reducer,
    session: sessionSlice.reducer,
    company: companySlice.reducer,
    kiosk: kioskSlice.reducer,
    user: userSlice.reducer,
    flag: featureFlagSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
